import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

export default function BusinessConsutation() {
    return (
        <>

            <div className='bg-white businessconsultation-bg-img' id='businessconsultation'>
                <section className="py-28" >
                    <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
                        <div className="max-w-xl space-y-3 md:mx-auto">
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className="text-white text-3xl font-bold sm:text-4xl mb-2">
                                    Business <span style={{ color: "#1fa1cb" }}>Consultation</span>
                                </h3>
                                <p className="text-white">
                                    Business consultation for setting up a new company in Dubai involves comprehensive
                                    support and guidance provided by experienced professionals to navigate the
                                    complexities of establishing and operating a business in the emirate. Here's a detailed
                                    description:
                                </p>
                            </ScrollAnimation>
                        </div>
                    </div>
                </section>
            </div>

            <div className='bg-white'>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Initial   <span style={{ color: "#1fa1cb" }}>Assessment :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Experienced consultants conduct an initial assessment to understand the client's
                                        business goals, industry sector, target market, and specific requirements.
                                    </p>
                                </ScrollAnimation>
                            </div>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInRight">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Market    <span style={{ color: "#1fa1cb" }}>Research :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Conducting market research to identify business opportunities, market demand,
                                        competition, and regulatory requirements.
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex mt-5" style={{ marginTop: 50 }}>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Business Setup  <span style={{ color: "#1fa1cb" }}>Options :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Providing guidance on the most suitable company structure and legal entity
                                        based on the client's objectives, such as free zone company, mainland company,
                                        or offshore company.
                                    </p>
                                </ScrollAnimation>
                            </div>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInRight">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Licensing and   <span style={{ color: "#1fa1cb" }}>Registration :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Assisting with obtaining the necessary licenses, permits, and approvals from
                                        relevant government authorities, such as the Department of Economic
                                        Development (DED), free zone authorities, or specialized regulatory bodies
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex mt-5" style={{ marginTop: 50 }}>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Corporate <span style={{ color: "#1fa1cb" }}> Governance :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Advising on corporate governance practices, compliance requirements, and legal
                                        obligations to ensure the business operates in accordance with local laws and
                                        regulations.
                                    </p>
                                </ScrollAnimation>
                            </div>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInRight">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Location <span style={{ color: "#1fa1cb" }}>Selection :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Recommending suitable business locations based on the nature of the business,
                                        budget, accessibility, and proximity to key markets, suppliers, and customers.
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex mt-5" style={{ marginTop: 50 }}>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Financial <span style={{ color: "#1fa1cb" }}> Planning :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Providing financial planning and budgeting assistance, including capital
                                        investment requirements, cash flow projections, and financial feasibility analysis.
                                    </p>
                                </ScrollAnimation>
                            </div>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInRight">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Taxation and <span style={{ color: "#1fa1cb" }}>Accounting :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Offering guidance on taxation policies, VAT registration, accounting practices,
                                        and financial reporting standards to ensure compliance with local tax regulations
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex mt-5" style={{ marginTop: 50 }}>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Visa and  <span style={{ color: "#1fa1cb" }}>  Immigration Services :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Assisting with visa and immigration procedures for business owners, investors,
                                        employees, and their families, including residency permits, work permits, and
                                        sponsorship services.
                                    </p>
                                </ScrollAnimation>
                            </div>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInRight">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Business <span style={{ color: "#1fa1cb" }}>Networking :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Facilitating networking opportunities with industry experts, government officials,
                                        potential partners, suppliers, and investors to build strategic alliances and
                                        business relationships.

                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex mt-5" style={{ marginTop: 50 }}>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Ongoing  <span style={{ color: "#1fa1cb" }}>  Support :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Providing ongoing support and advisory services post-setup, including business
                                        expansion strategies, operational efficiency enhancements, and risk management
                                        solutions.

                                    </p>
                                </ScrollAnimation>
                            </div>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInRight">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Digital <span style={{ color: "#1fa1cb" }}>Transformation :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Advising on digital transformation initiatives, including the adoption of
                                        technology solutions, e-commerce platforms, digital marketing strategies, and
                                        cybersecurity measures to enhance business competitiveness and efficiency

                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex mt-5" style={{ marginTop: 50 }}>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Cultural and  <span style={{ color: "#1fa1cb" }}> Market Sensitivity:</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Offering insights into local culture, business etiquette, and market dynamics to
                                        help clients navigate cultural nuances and build successful business relationships
                                        in Dubai and the broader UAE market.
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div style={{ marginTop: 30 }}>
                            <p className="mt-3  text-gray-500 font-medium">
                                In summary, business consultation for new company setup in Dubai encompasses a
                                holistic approach aimed at guiding clients through every stage of the business setup
                                process, from initial planning and registration to ongoing operations and growth
                                strategies, while ensuring compliance with local laws and regulations.
                            </p>
                        </div>
                    </div>
                </section>
            </div>

            <div className="container-fluid main-freezone-contact-img main-freezone-contact">
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto px-4 md:px-8">
                        <div className="max-w-xl">
                            <h3 className="text-5xl font-bold text-white mb-5" style={{ letterSpacing: 1 }}>
                                Have a question?<br></br>
                                Get in touch today
                            </h3>
                            <p className="text-white mt-5 font-semibold" style={{ marginTop: 30 }}>
                                Our experts are always available to answer your queries.
                            </p>
                            <a href="https://wa.me/+971507668212" target='_blank' rel="noreferrer">
                                <button class="whatsapp-btn" style={{ marginTop: 30 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="25" width="25"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" id="mainIconPathAttribute" fill="#ffffff"></path></svg>
                                    WhatsApp
                                </button>
                            </a>

                            <a href="tel:+971507668212" >
                                <button class="phone-number" style={{ marginTop: 30 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="grey" class="bi bi-telephone" viewBox="0 0 16 16" id="IconChangeColor">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" id="mainIconPathAttribute"></path>
                                    </svg>
                                    +971 56 265 7300
                                </button>
                            </a>



                        </div>
                    </div>
                </section>
            </div>

            <div className=''>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="flex-1 sm:hidden lg:block" style={{ marginBottom: 200 }}>
                                <div className="fb-iframe-container">
                                    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fweb.facebook.com%2Fdubaisetupinfo.co&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                        width="1240" height="500" className='fb-frame' style={{ border: 'none', overflow: 'hidden' }} scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                                </div>
                            </div>
                            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                                <div className="fb-container-text">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-4xl mb-5">
                                        Dubai Setup  <span className="text-customLightBlue">Facebook Page</span>
                                    </h3>
                                    <p className="text-gray-900 text-1xl font-normal sm:text-1xl ">
                                        This company's Facebook page is a testament to their dedication to excellence, fostering a vibrant community, and showcasing their creativity. With captivating content and interactive engagement, they go beyond mere promotion, building genuine connections with their audience. Each post tells a story, evoking emotions and leaving a lasting impression on followers. Their commitment to innovation shines through in every aspect of their page, setting them apart from the competition. Moreover, they prioritize customer satisfaction, ensuring transparency and authenticity in all interactions. Their page serves as a window into their values and aspirations, inspiring trust and loyalty among their followers. Overall, this company's Facebook presence embodies their passion for making a difference and leaves a lasting impact on all who engage with it.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}
